import styled from 'styled-components';

import {
  flexbox,
  flexDirection,
  flexGrow,
  alignItems,
  justifyContent
} from '../../../../styles/helpers/flexbox';

import { widthFillAvailable } from '../../../../styles/helpers/common';

export const ResultContainer = styled.div`
  ${flexbox()};
  ${flexDirection('column')};
  ${alignItems('center')};
  ${widthFillAvailable()};
  height: 100%;
`;

export const DisplayHighlightsContainer = styled.div`
  text-align: left;
  ${flexbox()};
  ${flexDirection('column')};
  ${alignItems('center')};
  ${justifyContent('space-evenly')};
  ${widthFillAvailable()};
`;

export const ResultsHeading = styled.div((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${justifyContent('center')};
    ${alignItems('center')};
  
    background-color: white;
    border: 1px solid ${colours.grey[300]};
    border-radius: 15px 15px 0px 0px;
    border-bottom: none;
    height: 38px;
    width: 148px;
    padding-top: 5px;
    margin-bottom: -6px;
    z-index: 1;
    `;
});

export const ResultsWrapper = styled.div((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${alignItems('center')};
    ${flexGrow('1')};
    ${widthFillAvailable()};

    margin-top: -1px;
    border: 1px solid ${colours.grey[300]};
    border-radius: 15px;
    padding: 25px 10px 10px 20px;
  `;
});

export const AttemptsWrapper = styled.div`
  ${flexbox()};
  ${flexDirection('column')};
  ${alignItems('center')};
  ${justifyContent('space-evenly')};

  width: 70%;
`;

export const DisplayResultsContainer = styled.div`
  ${flexbox()};
  ${justifyContent('space-evenly')};

  width: 100%;
`;

export const HighlightContainer = styled.div((props) => {
  const { colours } = props.theme;

  return `
  border-radius: 4px 4px 0 0;
  border: 1px solid ${colours.grey[300]};
  height: fit-content;
`;
});

export const Footer = styled.div`
  ${flexbox()};
  ${justifyContent('flex-end')};

  width: 100%;
  margin-top: 10px;

  .okButton {
    height: 29px;
    width: 86px;
    border-radius: 14.5px;
    font-size: 11px;
    padding: 0;
  }
`;

export const IconWrapper = styled.div`
  margin-right: 10px;
  width: 20px;
  height: 20px;
`;

export const ChartWrapper = styled.div`
  ${flexbox()};
  ${alignItems('center')};
  ${justifyContent('space-evenly')};

  width: 250px;
`;

export const DisplayHighlights = styled.div`
  ${flexbox()};

  width: 83%;
  height: 22px;
  font-size: 12px;
  font-weight: 800;
  text-align: left;
  text-rendering: geometricPrecision;
`;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-result/student-result.styled.js